<template>
  <div v-if="$store.state.loading" class="lds-dual-ring"></div>
</template>

<script>
  export default {}
</script>

<style>
  .lds-dual-ring {
    position: fixed;
    z-index: 9999;
    right: 50px;
    bottom: 50px;
    display: inline-block;
    width: 64px;
    height: 64px;
  }
  .lds-dual-ring:after {
    content: " ";
    display: block;
    width: 46px;
    height: 46px;
    margin: 1px;
    border-radius: 50%;
    border: 5px solid #ffc107;
    border-color: #ffc107 transparent #ffc107 transparent;
    animation: lds-dual-ring 1.2s linear infinite;
  }
  @keyframes lds-dual-ring {
    0% {
      transform: rotate(0deg);
    }
    100% {
      transform: rotate(360deg);
    }
}
</style>
